import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  EmailShareButton,
  EmailIcon,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share';
import { ShareModalWrapper } from './styles';


class ShareModal extends Component {
  handleClose = () => {
    const { onClose } = this.props;
    onClose();
  }

  render() {
    const { open, docUrl, literals } = this.props;

    return (
      <ShareModalWrapper
        open={open}
        onClose={this.handleClose}
      >
        <div className='modal share_modal'>
          <div className='title'>
            <h2>
              {literals.title}
            </h2>
          </div>
          <div className='sm_icons'>
            <div className='icon_fb'>
              <FacebookShareButton url={docUrl}>
                <FacebookIcon size={40} borderRadius={50} />
              </FacebookShareButton>
            </div>
            <div className='icon_tw'>
              <TwitterShareButton url={docUrl}>
                <TwitterIcon size={40} borderRadius={50} />
              </TwitterShareButton>
            </div>
            <div className='icon_whatsapp'>
              <WhatsappShareButton url={docUrl}>
                <WhatsappIcon size={40} borderRadius={50} />
              </WhatsappShareButton>
            </div>
            <div className='icon_mail'>
              <EmailShareButton url={docUrl}>
                <EmailIcon size={40} borderRadius={50} />
              </EmailShareButton>
            </div>
          </div>
        </div>

      </ShareModalWrapper>
    );
  }
}

ShareModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  docUrl: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
};

export default ShareModal;



// WEBPACK FOOTER //
// ./src/components/ShareModal/components/index.jsx